
























import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class Loading extends Vue {
  //Загрузка
  @Prop({required: false, default: true}) loading!: boolean;

  //Текст
  @Prop({required: false}) loadingText!: string;

  //Цвет
  @Prop({required: false, default: 'blue'}) loadingColor!: string;

  //Ошибка при загрузке
  @Prop({required: false, default: false}) error!: boolean;

  //Размер прогресс-бара
  @Prop({required: false, default: 60}) loadingSize!: number;

  //Ширина прогресс-бара
  @Prop({required: false}) loadingWidth!: number;

  //Внутренний
  @Prop({required: false, default: false}) inner!: boolean;
}
